import {useEffect} from 'react';

/**
 * Breite des Seitenmenüs des Ordermanagements als CSS-Variable `--oe-menu-w`
 * am Wurzelelement bereitstellen.
 *
 * Die schwebende Speicherleiste des Editors sitzt wie im Original unten links,
 * darf dort aber nicht über dem Seitenmenü liegen. Das Menü (`.sidebar-nav`)
 * ist eine Flex-Spalte ohne feste Breite — sie ergibt sich aus dem Inhalt und
 * fällt unterhalb des lg-Umbruchs ganz weg (dann ist das Menü ein Overlay).
 * Deshalb wird sie gemessen statt fest verdrahtet; die Leiste rechnet mit
 * `left: calc(var(--oe-menu-w) + 22px)`.
 */
export default function useMenuOffset() {
    useEffect(() => {
        const root = document.documentElement;

        const messen = () => {
            const menu = document.querySelector('.sidebar-nav');
            // Unterhalb des Umbruchs liegt das Menü als Overlay über der Seite
            // (`offcanvas-lg`) und belegt keinen Platz — dann gilt 0.
            const breite = menu && menu.offsetParent !== null
                ? Math.round(menu.getBoundingClientRect().width)
                : 0;
            root.style.setProperty('--oe-menu-w', `${breite}px`);
        };

        messen();
        window.addEventListener('resize', messen);

        let ro = null;
        const menu = document.querySelector('.sidebar-nav');
        if (menu && typeof ResizeObserver !== 'undefined') {
            ro = new ResizeObserver(messen);
            ro.observe(menu);
        }

        return () => {
            window.removeEventListener('resize', messen);
            if (ro) {
                ro.disconnect();
            }
            root.style.removeProperty('--oe-menu-w');
        };
    }, []);
}
